import { render, staticRenderFns } from "./GroupsCombo.vue?vue&type=template&id=46e60724"
import script from "./GroupsCombo.vue?vue&type=script&lang=js"
export * from "./GroupsCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports